import { Partner } from 'types';
import { generateDocumentWithTags } from 'utils/generateDocumentWithTags';

type GenerateDividendDocument = {
  partner: Partner;
  templateId: string;
  operationId: string;
  societyId: string;
};

type GenerateDividendDocuments = {
  selectedPartners: Partner[];
  templateId: string;
  operationId?: string;
  societyId?: string;
};

const generateDividendDocument = async ({
  partner,
  templateId,
  operationId,
  societyId,
}: GenerateDividendDocument) => {
  if (!partner?._id) {
    return;
  }

  const documentName = `Dividendo_${partner?.name}.pdf`;

  await generateDocumentWithTags({
    documentId: templateId,
    documentName,
    sources: {
      partner: partner._id,
      dividend: operationId,
      society: societyId,
    },
    language: 'es',
    footerHtml: '',
  });
};

export const generateDividendDocuments = async ({
  selectedPartners,
  templateId,
  operationId,
  societyId,
}: GenerateDividendDocuments) => {
  const validData = templateId && operationId && societyId;
  if (!validData) {
    return;
  }
  await Promise.all(
    selectedPartners.map((partner) =>
      generateDividendDocument({
        partner,
        templateId,
        operationId,
        societyId,
      })
    )
  );
};
